<template>
  <div class="together">
    <div class="container together-container">
      <div class="together-left">
        <span class="together-text">Присоединяйся к акции взаимопомощи во время пандемии коронавируса</span>
        <div class="together-hashtag"><TogetherHashtag/></div>
        <a href="https://xn--2020-f4dsa7cb5cl7h.xn--p1ai/" target="_blank" class="together-link">Присоединится</a>
      </div>
      <div class="together-right">
        <img src="/images/together-people.png" alt="мывместе">
      </div>
    </div>
  </div>
</template>

<script>
import TogetherHashtag from '@/assets/svg/together-hashtag.svg';

export default {
  components: {
    TogetherHashtag,
  }
}
</script>

<style lang="scss" scoped>
.together {
  background: url('/images/together_bg.jpg');
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  z-index: 2;
  &-container {
    height: 483px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-left {
    max-width: 430px;
  }
  &-text {
    display: block;
    font-size: 23px;
    color: #fff;
    margin-bottom: 7px;
  }
  &-hashtag {
    margin-bottom: 52px;
    & path {
      fill: #fff;
    }
  }
  &-link {
    display: flex;
    width: 280px;
    height: 60px;
    box-shadow: 0 3px 6px rgba(181, 91, 31, 0.69);
    border-radius: 5px;
    background-color: #ffffff;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    color: #f27f31;
    font-size: 20px;
    font-weight: bold;
    text-decoration: none;
    &:hover {
      color: #fff;
      background: #f27f31;
    }
  }
}

@media screen and (max-width: 767px) { 
  .together {
    background-size: cover;
    &-text {
      text-align: center;
      font-size: 20px
    }
    &-hashtag {
      text-align: center;
      margin-top: 5px;
    }
    &-link {
      margin: 0 auto;
    }
    &-container {
      flex-wrap: wrap;
      padding-top: 20px;
      padding-bottom: 30px;
      height: auto;
    }
    &-left {
      order: 2;
      width: 100%;
      max-width: 100%;
    }
    &-right {
      order: 1;
      width: 100%;
      text-align: center;
      margin-bottom: 30px;
      & img {
        height: 265px;
      }
    }
  }
}
</style>